export const UserKeys = {
  all: ["users"] as const,
  user: () => [...UserKeys.all, "detail"] as const,
  users: (offset: number, limit: number) =>
    [...UserKeys.all, "users", offset, limit] as const,
  lists: () => [...UserKeys.all, "list"] as const,
  list: (filters: { name?: string | null; offset: number; limit: number }) =>
    [...UserKeys.lists(), filters] as const,
  detail: (id: number) => [...UserKeys.user(), id] as const,
};
